import { Controller } from '@hotwired/stimulus';

// SCSS clamps .review-body to 5 lines; JS toggles is-truncated / is-expanded from overflow.
export default class extends Controller {
  connect() {
    this.refresh();
    this.observer = new ResizeObserver(() => this.refresh());
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer.disconnect();
  }

  refresh() {
    const el = this.element;
    if (el.classList.contains('is-expanded')) return;

    el.classList.toggle('is-truncated', el.scrollHeight > el.clientHeight);
  }

  toggle() {
    const el = this.element;
    if (!el.matches('.is-truncated, .is-expanded')) return;

    const expanded = el.classList.toggle('is-expanded');
    el.classList.toggle('is-truncated', !expanded);
  }
}
